import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Users, TrendingUp, Shield, Zap, CheckCircle, Star } from 'lucide-react';

const CRMPage = () => {
  const features = [
    'Gestão completa de potenciais clientes e oportunidades',
    'Automação de processos de vendas',
    'Análise de desempenho em tempo real',
    'Integração com redes sociais',
    'Relatórios personalizados',
    'Suporte multi-idiomas'
  ];

  const benefits = [
    { icon: TrendingUp, title: 'Aumento de Vendas', desc: '30% mais conversões com processos otimizados' },
    { icon: Shield, title: 'Dados Seguros', desc: 'Criptografia avançada e backup automático' },
    { icon: Zap, title: 'Automação', desc: 'Reduza tarefas manuais em até 70%' },
    { icon: Users, title: 'Equipa Unificada', desc: 'Colaboração perfeita entre departamentos' }
  ];

  return (
    <>
      <Header />
      <main className="min-h-screen bg-gray-50">
        {/* Hero Section */}
        <section className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-20 pt-32">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-5xl font-bold mb-6">Unisales-CRM</h1>
              <p className="text-xl mb-8 text-blue-100">
                Transforme o relacionamento com os seus clientes com a nossa solução completa de CRM.
                Aumente vendas, melhore satisfação e impulsione o crescimento do seu negócio.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button className="bg-white text-blue-700 px-8 py-3 rounded-full font-semibold hover:bg-blue-50 transition duration-300">
                  Agendar Demonstração
                </button>
                <Link to="/contact" className="border-2 border-white text-white px-8 py-3 rounded-full font-semibold hover:bg-white hover:text-blue-700 transition duration-300">
                  Fale Conosco
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Overview Section */}
        <section className="py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <div className="grid md:grid-cols-2 gap-12 items-center">
                <div>
                  <h2 className="text-3xl font-bold mb-6">Por que escolher Unisales-CRM?</h2>
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    A nossa solução de CRM foi desenvolvida para empresas que procuram excelência no relacionamento com clientes.
                    Com interface intuitiva e funcionalidades avançadas, terá controlo total sobre o seu pipeline de vendas,
                    histórico de interações e oportunidades de negócio.
                  </p>
                  <ul className="space-y-3">
                    {features.map((feature, index) => (
                      <li key={index} className="flex items-center">
                        <CheckCircle className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" />
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="bg-white p-8 rounded-2xl shadow-xl">
                  <div className="text-center">
                    <Users className="w-16 h-16 text-blue-600 mx-auto mb-4" />
                    <h3 className="text-2xl font-bold mb-4">Resultados Comprovados</h3>
                    <div className="grid grid-cols-2 gap-4">
                      <div className="text-center">
                        <div className="text-3xl font-bold text-blue-600">85%</div>
                        <p className="text-sm text-gray-600">Aumento em retenção</p>
                      </div>
                      <div className="text-center">
                        <div className="text-3xl font-bold text-blue-600">40%</div>
                        <p className="text-sm text-gray-600">Redução em tempo de resposta</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl font-bold mb-4">Benefícios Principais</h2>
              <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                Descubra como o Unisales-CRM pode transformar o seu negócio
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {benefits.map((benefit, index) => {
                const IconComponent = benefit.icon;
                return (
                  <div key={index} className="text-center p-6 rounded-xl hover:shadow-lg transition duration-300">
                    <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <IconComponent className="w-8 h-8 text-blue-600" />
                    </div>
                    <h3 className="text-xl font-semibold mb-3">{benefit.title}</h3>
                    <p className="text-gray-600">{benefit.desc}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        {/* <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl font-bold mb-4">O que os nossos clientes dizem</h2>
            </div>
            <div className="max-w-4xl mx-auto">
              <div className="bg-white p-8 rounded-2xl shadow-lg">
                <div className="flex items-center mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" />
                  ))}
                </div>
                <blockquote className="text-lg text-gray-700 mb-4">
                  "O Unisales-CRM revolucionou a nossa gestão de vendas. Conseguimos aumentar a nossa produtividade em 40%
                  e melhorar significativamente o relacionamento com os nossos clientes."
                </blockquote>
                <cite className="text-gray-600 font-semibold">
                  Maria Silva, Diretora de Vendas - TechCorp
                </cite>
              </div>
            </div>
          </div>
        </section> */}

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-r from-blue-600 to-purple-600 text-white">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold mb-4">Pronto para transformar o seu CRM?</h2>
            <p className="text-xl mb-8 text-blue-100">
              Agende uma demonstração gratuita e veja como podemos ajudar o seu negócio a crescer.
            </p>
            <button className="bg-white text-blue-700 px-8 py-3 rounded-full font-semibold hover:bg-blue-50 transition duration-300">
              Agendar Demonstração Gratuita
            </button>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default CRMPage;
